import PropTypes from 'prop-types';
import { Modal as ModalMUI, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import * as Styled from './Modal.styles';

export const Modal = ({ children, title, onClose }) => {
  return (
    <ModalMUI open>
      <Styled.Content sx={{ width: 600 }}>
        <Styled.Title>
          <span>{title}</span>
          {onClose && (
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          )}
        </Styled.Title>

        {children}
      </Styled.Content>
    </ModalMUI>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  onClose: PropTypes.func,
  sx: PropTypes.object,
};
